import {
  TranslocoTestingModule,
  TranslocoTestingOptions,
} from '@jsverse/transloco';

// Minimal translation object for testing
const enTranslations = {};
const arTranslations = {};

export function getTranslocoModule(options: TranslocoTestingOptions = {}) {
  return TranslocoTestingModule.forRoot({
    langs: { en: enTranslations, ar: arTranslations },
    translocoConfig: {
      availableLangs: ['en', 'ar'],
      defaultLang: 'en',
    },
    preloadLangs: true,
    ...options,
  });
}
